// extracted by mini-css-extract-plugin
module.exports = {"main":"Card_main__odW37","title":"Card_title__46mwY"};